import React from 'react';
import { CheckIcon } from 'lucide-react';
import { milestones } from '../data/portal';
import type { Loan } from '../types/portal';
export function MilestoneTracker({
  loan
}: {
  loan: Loan;
}) {
  const isClosed = loan.milestone === 'Closed';
  const current = milestones.indexOf(loan.milestone);
  return <ol className="grid grid-cols-7" aria-label="Loan milestones" data-id="element-145" data-mp="olurzdr83850">
      {milestones.map((m, i) => {
      const done = i < current || isClosed;
      const active = i === current && !isClosed;
      const date = loan.milestoneDates[m];
      return <li key={m} className="animate-fade-up relative flex flex-col items-center text-center" style={{
        '--d': `${80 + i * 40}ms`
      } as React.CSSProperties} aria-current={active ? 'step' : undefined} data-id="element-146" data-mp="xkyaogmh9liz" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" className={`absolute left-0 right-1/2 top-4 h-0.5 ${i <= current ? 'bg-ink' : 'bg-slate-200'}`} data-id="element-147" data-mp="1laaltm1d83nx" />}
            {i < milestones.length - 1 && <span aria-hidden="true" className={`absolute left-1/2 right-0 top-4 h-0.5 ${i < current ? 'bg-ink' : 'bg-slate-200'}`} data-id="element-148" data-mp="2eu18bjzslmsu" />}
            <span className={`relative z-10 flex h-8 w-8 items-center justify-center rounded-full ${done ? 'bg-ink text-white' : active ? 'border-2 border-accent bg-white' : 'border-2 border-slate-200 bg-white'}`} data-id="element-149" data-mp="2ot9x7yfswb8c">
              {done && <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-150" data-mp="32m86mop2w3uw" />}
              {active && <span className="h-2.5 w-2.5 rounded-full bg-accent" data-id="element-151" data-mp="37iox3pjr2ub5" />}
            </span>
            <span className={`mt-3 whitespace-nowrap text-[13px] ${done ? 'font-medium text-slate-900' : active ? 'font-semibold text-accent-dark' : 'font-medium text-slate-400'}`} data-id="element-152" data-mp="3cjmcjuddla8y">
              {m}
            </span>
            <span className="mt-0.5 text-xs tabular-nums text-slate-500" data-id="element-153" data-mp="1cguwyjhw1h5f">
              {done && date ? date : active ? `Current · since ${date ?? ''}` : '\u00A0'}
            </span>
            <span className="sr-only" data-id="element-154" data-mp="1lh03krf9cbij">{done ? 'Completed' : active ? 'Current step' : 'Not started'}</span>
          </li>;
    })}
    </ol>;
}